export default {"src":"/_next/static/media/boundary_on-light.40f8f8b3.svg","height":72,"width":234,"blurWidth":0,"blurHeight":0};